export default "__VITE_ASSET__DAs_DvZ6__"